module.exports = "/dashboard/manage/users/edit-unavailability-58334e.html";